var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "digital-flipper" },
    _vm._l(_vm.digits, function(item, index) {
      return _c("Flip", {
        key: index,
        attrs: { "auto-play": index === 3, count: item, duration: 500 }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }